// src/components/BenefitCard.js

function BenefitCard({ icon, title, description }) {
  return (
    <div className="col-12 col-md-6 col-lg-4">
      <div
        className="card h-100 shadow-sm p-4"
        style={{
          backgroundColor: 'white', // Card background is WHITE
          borderRadius: '12px',
          transition: 'transform 0.3s ease, box-shadow 0.3s ease, border-color 0.3s ease',
          border: '0px solid transparent',
          cursor: 'pointer',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.transform = 'translateY(-10px)';
          e.currentTarget.style.boxShadow = '0 12px 24px rgba(0, 0, 0, 0.15)';
          e.currentTarget.style.borderColor = 'var(--primary-brand-light)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.transform = 'translateY(0)';
          e.currentTarget.style.boxShadow = '0 2px 10px rgba(0, 0, 0, 0.1)';
          e.currentTarget.style.borderColor = 'transparent';
        }}
      >
        <div className="mb-3">{icon}</div>
        <h5 className="fw-bold" style={{ color: 'var(--primary-brand-dark)' }}>{title}</h5>
        <p className="text-muted">{description}</p>
      </div>
    </div>
  );
}

export default BenefitCard;